import type { Variants, Transition } from "framer-motion";

// Spring physics for premium feel — gentle settling, no overshoot.
export const easeOut: Transition = { duration: 0.7, ease: [0.16, 1, 0.3, 1] };
export const easeSpring: Transition = { type: "spring", stiffness: 90, damping: 18, mass: 0.9 };

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: easeOut },
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.5, ease: "easeOut" } },
};

// Stagger container — children inherit fadeUp via `variants={fadeUp}` on each child.
export const staggerSlow: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.12, delayChildren: 0.05 },
  },
};

export const staggerFast: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.05 },
  },
};

export const viewportOnce = { once: true, amount: 0.15 };
